import {deleteEventImage} from '../../../service/events/events-api';
import {useUploadEventImage} from '../../../service/events/events-hook';
import {EventFormFieldsEnum, EventFormType} from '../../../service/events/events-type';
import {Form} from '../../../typings/antd';
import {noop} from '../../../util/function';
import {
    PUBLICATION_MEDIA_MAX_HEIGHT,
    PUBLICATION_MEDIA_MAX_WIDTH,
    PUBLICATION_MEDIA_MIN_HEIGHT,
    PUBLICATION_MEDIA_MIN_WIDTH,
    PublicationMediaStep,
} from '../../publication-wizard/publication-media-step';
import {Text} from '../../text/text';

const EVENT_MAX_IMAGES = 10;

type PropsType = {
    onPreviousStep: VoidFunction;
    onStepFinished: VoidFunction;
    onStepActivated: (width: number) => void;
    width: number;
};

const banner = (
    <>
        <Text block bolder stringKey="YANDEX_STORY_FORM__UPLOAD_IMAGES__RULES_1" />
        <Text block stringKey="YANDEX_STORY_FORM__UPLOAD_IMAGES__RULES_2" />
        <Text
            block
            stringKey="YANDEX_STORY_FORM__UPLOAD_IMAGES__RULES_3"
            valueMap={{
                maxHeight: PUBLICATION_MEDIA_MAX_HEIGHT,
                maxWidth: PUBLICATION_MEDIA_MAX_WIDTH,
                minHeight: PUBLICATION_MEDIA_MIN_HEIGHT,
                minWidth: PUBLICATION_MEDIA_MIN_WIDTH,
            }}
        />
    </>
);

// Multiple images for events.
export function EventMediaStep(props: PropsType): JSX.Element {
    const {onPreviousStep, onStepFinished, onStepActivated, width} = props;

    const {mutateAsync: uploadImage} = useUploadEventImage();

    return (
        <Form.Item<EventFormType> name={EventFormFieldsEnum.Images} noStyle>
            <PublicationMediaStep
                banner={banner}
                maxCount={EVENT_MAX_IMAGES}
                onPreviousStep={onPreviousStep}
                onStepActivated={onStepActivated}
                onStepFinished={onStepFinished}
                remove={(imageId) => deleteEventImage(imageId).catch(noop)}
                upload={(file) => uploadImage(file)}
                uploaderHintLangKey="YANDEX_STORY_FORM__UPLOAD_IMAGES__UPLOADER_MAX_IMAGES"
                uploaderTextLangKey="YANDEX_STORY_FORM__UPLOAD_IMAGES__UPLOADER_TEXT"
                width={width}
            />
        </Form.Item>
    );
}
